import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0b0807] relative overflow-hidden border-t border-amber-100/10">
      <div className="container mx-auto px-4 relative z-10">
        {/* Main Footer Content */}
        <div className="py-16 md:py-24">
          <div className="max-w-4xl mx-auto text-center">
            {/* Company Info */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="mb-12 md:mb-16"
            >
              <h3 className="text-2xl md:text-3xl font-light text-amber-50 mb-5 md:mb-6 tracking-wider">
                KAÇKAR KARAFIRIN
              </h3>
              <p className="text-amber-100/70 mb-8 leading-relaxed font-light text-base md:text-lg max-w-2xl mx-auto">
                1992 yılından bu yana geleneksel lezzetleri modern tekniklerle 
                birleştirerek, müşterilerimize en kaliteli ürünleri sunuyoruz.
              </p>
            </motion.div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="grid md:grid-cols-3 gap-10 md:gap-16 mb-12 md:mb-16"
            >
              <div>
                <h4 className="text-lg font-light text-amber-50 mb-4">Adres</h4>
                <p className="text-amber-100/70 font-light text-sm md:text-base">
                  Arapçeşme mahallesi yeni bağdat cad. No:657/A Kaçkar Karafırın<br />
                  Gebze/ KOCAELI
                </p>
              </div>
              <div>
                <h4 className="text-lg font-light text-amber-50 mb-4">Telefon</h4>
                <p className="text-amber-100/70 font-light text-sm md:text-base">05447404153<br />02626428749</p>
              </div>
              <div>
                <h4 className="text-lg font-light text-amber-50 mb-4">E-posta</h4>
                <p className="text-amber-100/70 font-light text-sm md:text-base break-all">info@kackarkarafirin.com</p>
              </div>
            </motion.div>

            {/* Social Media */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="mb-16"
            >
              <div className="flex justify-center">
                <motion.a
                  href="https://instagram.com/kackarkarafirin"
                  target="_blank"
                  rel="noreferrer"
                  whileHover={{ scale: 1.06 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="Instagram @kackarkarafirin"
                  className="text-amber-100/65 hover:text-amber-50 transition-colors"
                >
                  <Instagram size={24} />
                </motion.a>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Bottom Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="border-t border-amber-100/10 py-8 text-center"
        >
          <div className="text-amber-100/60 font-light">
            © {currentYear} Kaçkar Karafırın. Tüm hakları saklıdır.
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 